import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { UiService } from "app/helper-components/UiService";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { environment } from "environments/environment";
export class ststus {
  notes: string;
  id: number;
}

@Component({
  selector: "app-meeting-checklist",
  templateUrl: "./meeting-checklist.component.html",
  styleUrls: ["./meeting-checklist.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MeetingChecklistComponent implements OnInit {
  parameters: any = {};
  appointments: any;
  member_list: any;
  question_id: any;
  answer: any = "";
  party_post_id: any;
  member_id: any;
  appointmentsId: any;
  showCheck = true;
  select = false;
  unSelect = false;
  Event: any;
  Status: ststus[] = [
    {
      id: 1,
      notes: "முந்தைய மாதத்தில் நடந்த அனைத்து நிகழ்வுகளும் பரிசீலிக்கப்பட்டதா?",
    },
    {
      id: 2,
      notes:
        "முந்தைய மாத வரவு-செலவு, சந்தா விவரங்கள் அனைத்தும் முழு கணக்கு அறிக்கை தாக்கல் செய்யப்பட்டதா?",
    },
    {
      id: 3,
      notes:
        "வரும் மாதத்தில் நடத்த இருக்கும் நிகழ்வுகள் மற்றும் நிதி பங்கீடுகள் திட்டமிடப்பட்டதா?",
    },
    {
      id: 4,
      notes:
        "வரும் மாதத்தின் குறைந்தபட்ச செயல்திட்டங்கள் பற்றி திட்டமிடப்படப்பட்டதா? (உதாரணம்)",
    },
    {
      id: 5,
      notes:
        "வருகைப்பதிவேட்டில் கலந்தாய்வில் கலந்து கொண்டவர்களின் கையொப்பம் வாங்கப்பட்டு “தொகுதி கலந்தாய்வு நிகழ்வு” பதிவேற்றம் செய்யப்பட்டதா?",
    },
    {
      id: 6,
      notes:
        "தீர்மானங்கள் நிறைவேற்றப்பட்டிருந்தால், அந்த தீர்மான நகல் “பொறுப்பாளர் நியமன தீர்மானம்” என்ற நிகழ்வு பகுதியில் பதிவேற்றம் செய்யப்பட்டதா?",
    },
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog_param: any,
    public matDialogRef: MatDialogRef<MeetingChecklistComponent>,
    private uiService: UiService,
    private postService: PostService,
    private activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private _translate: TranslateService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {
    this.appointments = dialog_param;
    this.parameters = dialog_param.parameters;
    this.appointmentsId = this.appointments.appointment_id;
  }

  ngOnInit(): void {
    if (this.appointments.status == 0) {
      this.showCheck = false;
    }

    this.uiService.showLoading();

    const formData = new FormData();
    formData.append("getPartyPersonsForConstituency", "1");
    formData.append("const_id", this.parameters.const_id);
    formData.append("barrack_id", this.parameters.barrack_id);
    this.postService
      .post(environment.API_PARTY_POST, formData)
      .subscribe((val) => {
        this.member_list = val.data;
        this.uiService.hideLoading();
      });
  }

  isSelected(): boolean {
    if (this.appointments.status == 0) {
      return true;
    }
  }

  changeSelection(event, note: any) {
    this.question_id = note.id;

    if (event.checked == true) {
      this.answer = 1;

      this.uiService.showLoading();

      const formData = new FormData();
      formData.append("updateAnswer", "1");
      formData.append("appointment_id", this.appointmentsId);
      formData.append("question_id", this.question_id);
      formData.append("answer", this.answer);
      this.postService
        .post(environment.API_CHECKLIST, formData)
        .subscribe((val) => {
          this._translate.get("Successfully Added.").subscribe((msg) => {
            this._snackBar.open(msg, "Close", {
              panelClass: "snack-success",
            });
          });
          this.uiService.hideLoading();
        });
    } else {
      this.answer = 0;
      this.uiService.showLoading();

      const formData = new FormData();
      formData.append("updateAnswer", "1");
      formData.append("appointment_id", this.appointmentsId);
      formData.append("question_id", this.question_id);
      formData.append("answer", this.answer);
      this.postService
        .post(environment.API_CHECKLIST, formData)
        .subscribe((val) => {
          this._translate.get("Successfully Removed.").subscribe((msg) => {
            this._snackBar.open(msg, "Close", {
              panelClass: "snack-danger",
            });
          });
          this.uiService.hideLoading();
        });
    }
  }

  changeAttendance(event, list) {
    this.party_post_id = list.party_post_id;
    this.member_id = list.member_id;

    if (event.checked == true) {
      this.answer = 1;

      this.uiService.showLoading();

      const formData = new FormData();
      formData.append("addPartyPersonAttendance", "1");
      formData.append("appointment_id", this.appointmentsId);
      formData.append("party_post_id", this.party_post_id);
      formData.append("member_id", this.member_id);
      formData.append("status", this.answer);

      this.postService
        .post(environment.API_CHECKLIST, formData)
        .subscribe((val) => {
          this._translate.get("Successfully Added.").subscribe((msg) => {
            this._snackBar.open(msg, "Close", {
              panelClass: "snack-success",
            });
          });
          this.uiService.hideLoading();
        });
    } else {
      this.answer = 0;

      this.uiService.showLoading();

      const formData = new FormData();
      formData.append("addPartyPersonAttendance", "1");
      formData.append("appointment_id", this.appointmentsId);
      formData.append("party_post_id", this.party_post_id);
      formData.append("member_id", this.member_id);
      formData.append("status", this.answer);

      this.postService
        .post(environment.API_CHECKLIST, formData)
        .subscribe((val) => {
          this._translate.get("Successfully Removed.").subscribe((msg) => {
            this._snackBar.open(msg, "Close", {
              panelClass: "snack-danger",
            });
          });
          this.uiService.hideLoading();
        });
    }
  }

  save() {
    const formData = new FormData();
    formData.append("submitChecklist", "1");
    formData.append("appointment_id", this.appointmentsId);

    this.postService
      .post(environment.API_CHECKLIST, formData)
      .subscribe((val) => {
        if (val.status == "success") {
          this.matDialogRef.close();
          this._translate.get("Successfully Added.").subscribe((msg) => {
            this._snackBar.open(msg, "Close", {
              panelClass: "snack-success",
            });
          });
        }

        this.uiService.hideLoading();
      });
  }

  showEmptyProfile(event) {
    event.target.src = "/assets/images/empty_profile_male.jpg";
  }

  close() {
    this.uiService.showLoading();
    this.matDialogRef.close();
    this.uiService.hideLoading();
  }

  mathakanaku() {
    this.matDialogRef.close();
    let key = this.helper.storePageData(this.parameters);
    this.router.navigateByUrl("/finance/closure?_v=" + key);
  }

  getAnswer(q_id: number) {
    let answers: Object = this.appointments.q_and_a.answers;
    if (answers && answers.hasOwnProperty(q_id)) {
      return answers[q_id].answer;
    }
    return false;
  }

  getPorupalargal(list: any) {
    this.party_post_id = list.party_post_id;
    let porupalargal: Object = this.appointments.q_and_a.porupalargal;
    if (porupalargal && porupalargal.hasOwnProperty(this.party_post_id)) {
      return porupalargal[this.party_post_id].active;
    }

    return 0;
  }
}
